// Matches theme.css --t-* and --ease-out variables
export const Motion = {
  fast:   100,
  base:   180,
  slow:   320,
  easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
};
